import { Popconfirm, Tag } from 'antd';
import { ButtonTheme, ButtonToolTip } from '../../../components/buttons';
import {
  createColumnButtonArr,
  createColumnText,
  widthOptions,
} from '../../../components/table/function';
import React from 'react';
import { color } from '../../../resources';

export const columns = ({ handleDeleteRecord, onOpenTracking }) => {
  return [
    createColumnText('เลขที่เคลม', 'claimCode', widthOptions(150)),
    createColumnText('ชื่อ-นามสกุล', 'fullName', widthOptions(150)),
    createColumnText('เบอร์ติดต่อ', 'telephone', widthOptions(150)),
    createColumnText('รหัสสินค้า', 'itemCode', widthOptions(140)),
    createColumnText('ชื่อสินค้า', 'productName', widthOptions(150)),
    createColumnText(
      'เลขพัสดุ',
      'trackingNumber',
      widthOptions(150, {
        render: (text, record) => {
          return (
            <div style={{ cursor: 'pointer' }}>
              <Tag color={color.blue_why} onClick={() => onOpenTracking(record)}>
                {text}
              </Tag>
            </div>
          );
        },
      }),
    ),
    createColumnButtonArr('จัดการ', 'rowNo', {
      others: {
        fixed: 'right',
        width: 150,
      },
      buttonArr: [
        {
          useFor: 'DELETE',
          render: (_, record) => {
            return (
              <ButtonToolTip toolTip="ลบ" placement="topLeft">
                <Popconfirm
                  title="คุณต้องการลบหรือไม่?"
                  onConfirm={() => handleDeleteRecord(record)}
                  okText="ใช่"
                  cancelText="ไม่"
                >
                  <ButtonTheme useFor="DELETE" />
                </Popconfirm>
              </ButtonToolTip>
            );
          },
        },
      ],
    }),
  ];
};
